<template>
  <div class="boisson">
    <button @click="zero">0</button>
    <button @click="change(-1)">&lt;</button>
    <button @click="change(1)" class="self" v-bind:class="{ maxed, mined }">{{count}} {{name}} {{ (maxed)? "!" : "" }}</button>
  </div>
</template>
<script>

import { bounded, set } from '@/lib/counted.js'

export default {
props: {'cb': {
type: Object,
required: true,
}
},
    computed: {
      name  () { return this.cb.item.nom; },
      count () { return this.cb.count; },
      maxed () { return this.count == this.max; },
      mined () { return this.count == this.min; },
    },
    methods: {
  change (delta) {
      let count = this.bounds(set(this.count, delta));
      this.$emit('set-boisson', {count, item: this.cb.item}); // -> { number, Item }
  },
  zero () { this.change(-this.count); },
    },
    data () { 
      let min = 0;
      let max = 10;
      return { min, max, bounds: bounded(min, max) };
    }
}
</script>
<style>
  .boisson {
  display:grid;
  grid-template-columns: 4em 4em 1fr;
  }

.boisson button {
  padding: 0;
  width: auto;
}
  
.boisson button.self {
  min-width: 12em;
  min-height: 4em;
}

.maxed {
  font-weight: bold;
  color: purpleo;
}

.mined {
  color: gray;
}
</style>
